export default __webpack_public_path__ + "static/media/group-16-copy.3042b27d.svg";